import React from "react";
import Text from "../atoms/Text";
import { ProfileAvatar, splitFullName } from "./ProfileShared";
import OrderHistoryProfile from "./OrderHistoryProfile";

export default function DashboardProfile({
  currentUser,
  billing,
  recentOrders,
  onOpenSettingsSection,
  onViewAllOrders,
  onSelectOrder,
}) {
  return (
    <div className="dashboard-profile" style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      <div
        className="dashboard-profile-top"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "24px",
        }}
      >
        <div
          style={{
            border: "1px solid var(--gray1)",
            borderRadius: "8px",
            padding: "32px 24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
            backgroundColor: "var(--white)",
          }}
        >
          <ProfileAvatar currentUser={currentUser} />
          <Text size="px20" weight="w500" color="gray9">
            {currentUser?.name || "Customer"}
          </Text>
          <Text size="px14" weight="w400" color="gray5">
            Customer
          </Text>
          <button
            type="button"
            onClick={() => onOpenSettingsSection("account")}
            style={{
              border: "none",
              backgroundColor: "transparent",
              color: "var(--primary)",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 500,
              fontFamily: "inherit",
              padding: 0,
              alignSelf: "center",
            }}
          >
            Edit Profile
          </button>
        </div>

        <div
          style={{
            border: "1px solid var(--gray1)",
            borderRadius: "8px",
            padding: "24px",
            backgroundColor: "var(--white)",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Text
            size="px12"
            weight="w500"
            color="gray4"
            extraStyles={{ textTransform: "uppercase" }}
          >
            Billing Address
          </Text>
          <Text size="px18" weight="w500" color="gray9">
            {`${billing.firstName || splitFullName(currentUser?.name).firstName} ${
              billing.lastName || splitFullName(currentUser?.name).lastName
            }`.trim() || currentUser?.name || billing.name}
          </Text>
          <Text
            size="px14"
            weight="w400"
            color="gray5"
            extraStyles={{ lineHeight: "150%" }}
          >
            {billing.address || "No address saved yet."}
          </Text>
          <Text size="px14" weight="w400" color="gray9">
            {billing.email || currentUser?.email}
          </Text>
          <Text size="px14" weight="w400" color="gray9">
            {billing.phone || "No phone saved yet."}
          </Text>
          <button
            type="button"
            onClick={() => onOpenSettingsSection("address")}
            style={{
              border: "none",
              backgroundColor: "transparent",
              color: "var(--primary)",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 500,
              fontFamily: "inherit",
              padding: 0,
              marginTop: "4px",
              textAlign: "center",
              alignSelf: "center",
              width: "fit-content",
            }}
          >
            Edit Address
          </button>
        </div>
      </div>

      <OrderHistoryProfile
        orders={recentOrders}
        onViewAll={onViewAllOrders}
        onSelectOrder={onSelectOrder}
      />
    </div>
  );
}
